import React from 'react'
import moment from 'moment'
import {Link} from 'react-router-dom'
import clsx from 'clsx'

import Box from '@mui/material/Box'
import CloseIcon from '@mui/icons-material/Close'
import Grid from '@mui/material/Grid';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {faUser} from "@fortawesome/free-solid-svg-icons";

import useStyles from './styles'

export default function StandardsAssessment({context}) {

  const classes = useStyles()

  const {quizAssessmentToReview: assessment, quizTypesMap, link, translate} = context

  const {studentName, content = {}, started, finished} = assessment 

  const {title, type} = content

  const typeName = translate(quizTypesMap[type])

  const closeLink = link({}, context.quizEditFrom || '/:languageId/:role/:page/assigned', {query: context.quizEditFromQuery})

  function formatDate (date) {
	return moment(date).format(context.languageId == 'es' ? 'DD/MM/YYYY' : 'MM/DD/YYYY')
  }

  return (
        <Grid container spacing={2}>
			<Grid item xs={8} md={8}>
					<Box className={classes.studentName}>
						<FontAwesomeIcon icon={faUser}/>
						{studentName}
					</Box>
			</Grid>
			<Grid item xs={4} md={4}>
					<Link className={clsx(classes.button, classes.close)} to={closeLink}>
        				<Box className="icon"><CloseIcon /></Box>
        				<Box className="label">{translate('close')}</Box>
        			</Link>
			</Grid>
			<Grid item xs={12} md={12} className={classes.grid}>
				<Box className={classes.title}>{typeName}: </Box>
				<Box className="type">{title}</Box>
			</Grid>
			<Grid item xs={12} md={5} className={classes.grid}>
				<Box className={classes.title}>{translate('standards-asigned')}: </Box>
				<Box className={classes.finished}>
					 {formatDate(started)}
				</Box>
			</Grid>
			<Grid item xs={12} md={5} className={classes.grid}>
				<Box className={classes.title}>{translate('standards-completed')}: </Box>
				<Box className={classes.finished}>
					 {formatDate(finished)}
			    </Box>
		    </Grid>
        </Grid>
  )
}
